export default "/_next/static/chunks/bust-3-d.1751493a9913d1994b4f9e03ec5e84dd.glb";